import { UserLocation } from '../entities';
import { LocationService } from './LocationService';

export class LocationServerService implements LocationService {
  // TODO should we load location?
  async getLocation(): Promise<UserLocation> {
    return {};
  }
}
